import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, useState } from 'react';
import { elementsButtonClasses } from './util';
import { ButtonSize, ButtonTheme } from './types';

interface LabeledIconButtonProps {
  label: string;
  icon: JSX.Element;
  size?: ButtonSize;
  hoverWidth: number;
  theme?: ButtonTheme;
  labelVisible?: boolean;
  initialDiameter?: number;
  className?: HTMLDivElement['className'];
}

export const LabeledIconButton: FC<LabeledIconButtonProps> = ({
  hoverWidth = 60,
  initialDiameter = 60,
  label,
  className,
  icon,
  size,
  theme = 'primary',
  labelVisible,
}) => {
  const [labelVisibleInner, setLabelVisibleInner] = useState(false);

  const runtimeLabelVisible = labelVisible || labelVisibleInner;

  return (
    <motion.button
      transition={{ ease: 'easeInOut' }}
      style={{ height: `${initialDiameter}px` }}
      whileHover={{ width: `${hoverWidth}px` }}
      initial={{ width: `${initialDiameter}px` }}
      onHoverEnd={() => setLabelVisibleInner(false)}
      onHoverStart={() => setLabelVisibleInner(true)}
      animate={{ width: `${runtimeLabelVisible ? hoverWidth : initialDiameter}px` }}
      className={clsx(
        'grid origin-right grid-flow-col place-content-center items-center overflow-hidden rounded-full py-[10px] !px-0',
        elementsButtonClasses.theme(theme),
        elementsButtonClasses.size(size),
        className
      )}
    >
      <motion.div layout="position" className={clsx(elementsButtonClasses.iconTheme(theme))}>
        {icon}
      </motion.div>
      <AnimatePresence mode="sync">
        {runtimeLabelVisible && (
          <motion.p
            layout="position"
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="ElementsButton-label ml-2 whitespace-nowrap text-[15px] font-bold leading-normal overflow-hidden text-ellipsis"
          >
            {label}
          </motion.p>
        )}
      </AnimatePresence>
    </motion.button>
  );
};
